import { useState } from "react";

import Details from "./Details";
import UploadPhoto from "./UploadPhoto";
import Payment from "./Payment";
import Receipt from "./Receipt";

export default function CoutoureClub({ cares }) {
	const [id, setId] = useState("");
	const [status, setStatus] = useState(4);
	/*
    0 - error submitting payment
    1 - receipt page
    2 - payment page
		3 - photo upload page
		4 - details page
  */

	const handleStatus = (id = "", status) => {
		setId(id);
		setStatus(status);
	};

	return (
		<>
			{id && status === 1 ? (
				<Receipt cares={cares} id={id} handleStatus={handleStatus} />
			) : id && status === 2 ? (
				<Payment cares={cares} id={id} handleStatus={handleStatus} />
			) : id && status === 3 ? (
				<UploadPhoto cares={cares} id={id} handleStatus={handleStatus} />
			) : (
				<Details cares={cares} id={id} handleStatus={handleStatus} />
			)}
		</>
	);
}
